module.exports = __webpack_public_path__ + "img/goldregen-2020-115.106dca87.jpg";